import React from "react";
import { AHTeamIconCircle, AHText, Box, useLayoutContext } from "arkh";
import Color from "color";
import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { formatValue } from "widgets/src/WidgetTaskSingle/NumberTask/formatNumber";

import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { useFragment, graphql } from "react-relay";

import { KPIListSectionHeader_taskExecutions$key } from "./__generated__/KPIListSectionHeader_taskExecutions.graphql";
import { KPIListSectionHeader_team$key } from "./__generated__/KPIListSectionHeader_team.graphql";
import { KPIUnit } from "../KPIAdmin/Edit/KPIEditParamList";

export const KPIListSectionHeader = React.memo(KPIListSectionHeaderC);
function KPIListSectionHeaderC(props: {
  team: KPIListSectionHeader_team$key;
  taskExecutions: KPIListSectionHeader_taskExecutions$key;
  unit: KPIUnit;
}) {
  const taskExecutions = useFragment(
    graphql`
      fragment KPIListSectionHeader_taskExecutions on TaskExecutionNumber
      @relay(plural: true) {
        numberValue
      }
    `,
    props.taskExecutions
  );
  const team = useFragment(
    graphql`
      fragment KPIListSectionHeader_team on Team {
        icon
        color
        name
        isPrivate
      }
    `,
    props.team
  );
  const intl_tokens = useIntlTokens();
  const layout = useLayoutContext();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;

  const totalNumberValue = taskExecutions.reduce(
    (acc, { numberValue }) => acc + (numberValue ?? 0),
    0
  );
  const [format, u] = formatValue(props.unit, totalNumberValue);

  return (
    <Box
      spaceTop="large"
      style={{
        backgroundColor: Color(team.color ?? "rgb(255,255,255)")
          .lightness(99)
          .toString(),
      }}
    >
      <Box
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        spaceHorizontal={isCompact ? "small" : "xlarge"}
      >
        <Box
          style={{
            width: layout.circle.medium,
            position: "absolute",
            height: "50%",
            zIndex: -1,
            top: "50%",
            left: isCompact ? layout.space.small : layout.space.xlarge,
            alignItems: "center",
          }}
        >
          <Box
            style={{
              width: 4,
              height: "100%",
              backgroundColor: team.color ?? undefined,
            }}
          />
        </Box>
        <AHTeamIconCircle
          type={team.icon ?? null}
          color={team.color ?? null}
          isPrivate={team.isPrivate}
          size="medium"
        />
        <AHText style={{ flex: 1 }} spaceHorizontal="small" type="title-small">
          {team.name}
        </AHText>
        <Box style={{ width: 135, alignItems: "flex-end" }}>
          <AHText
            type="info-small"
            style={{ position: "absolute", right: 0, top: -10 }}
          >
            {intl_tokens.Total}
          </AHText>
          <AHText type="title-small">
            {format(totalNumberValue)}
            {u ? ` ${u}` : ""}
          </AHText>
        </Box>
      </Box>
    </Box>
  );
}
